// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1wIRH","productName":"Table_productName__1FdMM"};